import React, { ReactElement } from "react";
import { BlockContent } from "components/BlockContent";
import { TextStyle, TextStyleProps } from "@silversea-ssc/ui-components-react";
import { BlockContentProps } from "components/BlockContent/BlockContent";
import { dequal } from "dequal/lite";

interface TextBoxProps extends TextStyleProps {
  preContent?: ReactElement;
  content: BlockContentProps["value"];
  tokens?: BlockContentProps["tokens"];
}

const TextBox: React.FC<React.PropsWithChildren<TextBoxProps>> = ({
  preContent,
  content,
  tokens,
  ...textContainerProps
}) => {
  return (
    <TextStyle {...textContainerProps}>
      {preContent}
      <BlockContent value={content} tokens={tokens} />
    </TextStyle>
  );
};

export default React.memo(TextBox, dequal);
